import { LicensesEnum } from '../monitoring/licenses.enum';

export enum SublicensesEnum {
    SMART_PROXY_ONLINE = 1,
    SMART_PROXY_POST_MEDIA = 2,
    SMART_PROXY_FRENCH_CANADIAN = 3,
    SMART_PROXY_LE_DEVOIR = 7,
    // refmedia is coded as sublicenses in the backend but we don't want to display them as sublicenses in the FE, the FE handles this logic
    REFMEDIA_ONLINE_PRINT = 4,
    REFMEDIA_PARLIAMENTARY  = 5,
    REFMEDIA_BROADCAST = 6
}

/**
 * Sublicenses are additional licenses under other licenses, this map shows that relation
 */
export const sublicenseMap = new Map<SublicensesEnum, LicensesEnum>([
    [SublicensesEnum.SMART_PROXY_ONLINE, LicensesEnum.SMART_PROXY],
    [SublicensesEnum.SMART_PROXY_POST_MEDIA, LicensesEnum.SMART_PROXY],
    [SublicensesEnum.SMART_PROXY_FRENCH_CANADIAN, LicensesEnum.SMART_PROXY],
    [SublicensesEnum.SMART_PROXY_LE_DEVOIR, LicensesEnum.SMART_PROXY],
    [SublicensesEnum.REFMEDIA_ONLINE_PRINT, LicensesEnum.REFMEDIA],
    [SublicensesEnum.REFMEDIA_PARLIAMENTARY, LicensesEnum.REFMEDIA],
    [SublicensesEnum.REFMEDIA_BROADCAST, LicensesEnum.REFMEDIA]
]);

export const sublicenseDefaultValue = new Map<SublicensesEnum, boolean>([
    [SublicensesEnum.SMART_PROXY_ONLINE, true],
    [SublicensesEnum.SMART_PROXY_POST_MEDIA, true],
    [SublicensesEnum.SMART_PROXY_FRENCH_CANADIAN, false],
    [SublicensesEnum.SMART_PROXY_LE_DEVOIR, false],
    [SublicensesEnum.REFMEDIA_ONLINE_PRINT, false],
    [SublicensesEnum.REFMEDIA_PARLIAMENTARY, false],
    [SublicensesEnum.REFMEDIA_BROADCAST, false]
]);
